import API from "./api";
import { queryClient } from "../lib/queryClient";
import { orgScope } from "./orgScope";

const ORG_STALE_MS = 60_000;
const SETUP_STALE_MS = 30_000;

function scoped(name) {
  return [name, orgScope()];
}

function readQuery(queryKey, queryFn, staleTime, fresh) {
  return queryClient.fetchQuery({
    queryKey,
    queryFn,
    staleTime: fresh ? 0 : staleTime,
  });
}

async function fetchOrganisationMeBody() {
  const { data } = await API.get("/organisation/me");
  return data;
}

async function fetchOrgProfileStatusBody() {
  const { data } = await API.get("/organisation/me/profile-status");
  return data;
}

async function fetchSetupStatusBody() {
  const { data } = await API.get("/setup/status");
  return data;
}

async function fetchWfSetupStatusBody() {
  const { data } = await API.get("/wf/setup/status");
  return data;
}

export function loadOrganisationMe({ fresh = false } = {}) {
  return readQuery(scoped("organisation-me"), fetchOrganisationMeBody, ORG_STALE_MS, fresh);
}

export function loadOrgProfileStatus({ fresh = false } = {}) {
  return readQuery(scoped("org-profile-status"), fetchOrgProfileStatusBody, SETUP_STALE_MS, fresh);
}

export function loadSetupStatus({ fresh = false } = {}) {
  return readQuery(scoped("setup-status"), fetchSetupStatusBody, SETUP_STALE_MS, fresh);
}

export function loadWfSetupStatus({ fresh = false } = {}) {
  return readQuery(scoped("wf-setup-status"), fetchWfSetupStatusBody, SETUP_STALE_MS, fresh);
}

export function loadSubscriptionFeatures({ fresh = false } = {}) {
  return readQuery(
    scoped("subscription-features"),
    async () => {
      const { data } = await API.get("/subscription/features");
      return data;
    },
    ORG_STALE_MS,
    fresh
  );
}

/** Drop every cached query. Call on logout and before a new login. */
export function clearAppQueries() {
  queryClient.clear();
}
